import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { EducatorDto } from '../../../../api-service/clients/auto-generated-clients';

const attendanceClient = moduleClientFactory.createAttendanceClient();

export function useCompanyEducators(companyId: string) {
  const { enqueueSnackbar } = useSnackbar();
  const [educators, setEducators] = useState<EducatorDto[]>([]);
  const [isLoadingEducators, setIsLoadingEducators] = useState(true);

  useEffect(() => {
    attendanceClient
      .getEducatorsByCompanyId({ companyId })
      .then(response => setEducators((response.educators ?? []).filter(educator => !educator.isDeleted)))
      .catch(() => enqueueSnackbar('Der skete en fejl ved hentning af undervisere', { variant: 'error' }))
      .finally(() => setIsLoadingEducators(false));
  }, [companyId]);

  return { educators, isLoadingEducators };
}
